import graphql__a91d4c854465362e6e6c from "./__generated__/PageSectionSidebarEventsList_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";

import SidebarEventCard from "../Events/SidebarEventCard.js";
import { useMapContext } from "../Maps/MapContext.js";
import MapSidebarEventsList from "../Maps/MapSidebarEventsList.js";

const PageSectionSidebarEventsList = props => {
  const pageSection = useFragment(
    PageSectionSidebarEventsList_pageSection,
    props.pageSection
  );
  const { events } = pageSection;

  const { mapKey: isMap } = useMapContext();
  // If the section is inside a map sidebar, we use a dedicated component to avoid mixing
  // classic sidebar and map sidebar logics here, as map sidebar events list have more
  // functionality than the classic one.
  if (isMap) return <MapSidebarEventsList eventsList={pageSection} />;

  return (
    <div className="boxes-list">
      <ul className="padding-none">
        {events.map(event => (
          <SidebarEventCard
            key={event.id}
            participativeModule={event}
            itemId={event.id}
            itemType="event"
          />
        ))}
      </ul>
    </div>
  );
};

const PageSectionSidebarEventsList_pageSection = graphql__a91d4c854465362e6e6c;

export default PageSectionSidebarEventsList;
